import { Link } from 'react-router-dom';

const LOGO = 'https://onecallhandymanhouston.com/insert-files/company-logo.png';

export default function Footer() {
  return (
    <footer className="bg-white text-gray-500 pt-16 pb-8 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-gray-100">

          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" className="block mb-5">
              <img
                src={LOGO}
                alt="One Call Handyman Service Houston"
                className="h-12 w-auto object-contain"
                onError={(e) => {
                  const img = e.target as HTMLImageElement;
                  img.style.display = 'none';
                  const span = document.createElement('span');
                  span.className = 'font-serif text-gray-900 text-lg font-semibold';
                  span.innerHTML = 'One Call <span style="color:#BF9448">Handyman</span>';
                  img.parentElement?.appendChild(span);
                }}
              />
            </Link>
            <p className="text-sm font-sans leading-relaxed text-gray-500 mb-5">
              Houston&rsquo;s trusted property solutions provider. Fair, honest, and done right the first time. Serving Houston TX and surrounding areas for 16+ years.
            </p>
            <a
              href="tel:3463638363"
              className="inline-flex items-center gap-2 text-[#BF9448] text-sm font-sans font-medium cursor-pointer hover:text-[#D4AB5E] transition-colors duration-200 whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-base"></i>
              </span>
              346-363-8363
            </a>
          </div>

          {/* Services column */}
          <div>
            <h4 className="text-gray-900 text-xs font-sans font-semibold tracking-widest uppercase mb-5">Services</h4>
            <ul className="space-y-3">
              {['Make-Ready Remodeling', 'Flooring', 'Drywall & Painting', 'Electrical', 'Plumbing', 'Roofing'].map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="text-sm font-sans text-gray-500 hover:text-[#BF9448] transition-colors duration-200 cursor-pointer"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation column */}
          <div>
            <h4 className="text-gray-900 text-xs font-sans font-semibold tracking-widest uppercase mb-5">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'All Services', path: '/services' },
                { label: 'About Us', path: '/about' },
                { label: 'Service Areas', path: '/locations' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm font-sans text-gray-500 hover:text-[#BF9448] transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h4 className="text-gray-900 text-xs font-sans font-semibold tracking-widest uppercase mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#BF9448] text-base"></i>
                </span>
                <span className="text-sm font-sans text-gray-500">
                  8200 Jet Pilot St<br />Houston, TX 77075
                </span>
              </li>
              <li className="flex gap-3">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-[#BF9448] text-base"></i>
                </span>
                <a
                  href="tel:3463638363"
                  className="text-sm font-sans text-gray-500 hover:text-[#BF9448] transition-colors duration-200 cursor-pointer"
                >
                  346-363-8363
                </a>
              </li>
              <li className="flex gap-3">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-[#BF9448] text-base"></i>
                </span>
                <span className="text-sm font-sans text-gray-500">
                  7 Days a Week<br />Serving Houston &amp; surrounding areas
                </span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-sans text-gray-400">
            &copy; {new Date().getFullYear()} One Call Handyman Service. All Rights Reserved. Houston, TX 77075
          </p>
          <div className="flex gap-5">
            <a
              href="https://terms.siteslocal.com/site-terms.html"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-xs font-sans text-gray-400 hover:text-gray-600 transition-colors duration-200 cursor-pointer"
            >
              Terms of Use
            </a>
            <a
              href="https://terms.siteslocal.com/site-accessibility-statement.html"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-xs font-sans text-gray-400 hover:text-gray-600 transition-colors duration-200 cursor-pointer"
            >
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
